module.exports = __webpack_public_path__ + "media/teams/course_preview_one-39087f64.png";